import styled from 'styled-components'

interface IStatusCardLegacyContentRightStyledProps {}

export const StatusCardLegacyContentRightStyled = styled.div<IStatusCardLegacyContentRightStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  flex-grow: 1;
`
